import { SCENE_UBO_WGSL } from '../../shader/scene-uniforms.js';

function _registerEnvironmentSkyboxShaderPatch(scene, order, loadPatch) {
  const loaders = scene._environmentSkyboxShaderPatchLoaders ??= [];
  loaders[order] = loadPatch;
  scene._environmentSkyboxShaderComposer ??= async (fragment, kind) => {
    fragment = kind === "hdr" ? SCENE_UBO_WGSL + fragment : fragment;
    for (const load of loaders.slice()) {
      if (load) {
        fragment = (await load())._apply(fragment, kind);
      }
    }
    return fragment;
  };
}

export { _registerEnvironmentSkyboxShaderPatch };
//# sourceMappingURL=environment-skybox-shader-composer.js.map
